import React from "react";
import PropTypes from "prop-types";
import { FormControl } from "react-bootstrap";

const FunctionalInput = ({ label, name, type, value, disabled, onChange, validator }) => {
  const props = { type, name, disabled };
  return <div className="d-flex align-items-center">
    <span className="mr-2">{label}: </span>
    {
      disabled && <FormControl
                    {...props}
                    defaultValue={value}
                  />
    }
    {
      !disabled && (
          <div className="position-relative">
            <FormControl
                {...props}
                value={value}
                onChange={onChange}
                autoComplete="off"
            />
            {validator.message(label, value, "required")}
          </div>
      )
    }
  </div>;
};

FunctionalInput.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  value: PropTypes.string,
  validator: PropTypes.object,
  onChange: PropTypes.func
};

export default FunctionalInput;
